export const ORDER_ID_QUERY_PARAM_NAME = "orderId";
export const ORDER_REF_QUERY_PARAM_NAME = "orderRef";